import Vue from 'vue'
// @ts-ignore
import VueExpandableImage from 'vue-expandable-image'
Vue.use(VueExpandableImage)
